import { parseAdminNavigationState } from '../sectionRouting'
import type { UseAdminSectionRoutingParams } from '../useAdminSectionRouting.types'

type HydrationParams = Pick<
  UseAdminSectionRoutingParams,
  | 'setSection'
  | 'setSelectedUserId'
  | 'setSelectedShopProductId'
  | 'setPageEditorMode'
  | 'setPageEditorId'
>

export const hydrateSectionFromLocation = ({
  setSection,
  setSelectedUserId,
  setSelectedShopProductId,
  setPageEditorMode,
  setPageEditorId,
}: HydrationParams) => {
  const navigationState = parseAdminNavigationState(
    window.location.search,
    window.location.hash,
    window.location.pathname,
  )

  if (navigationState.section) {
    setSection(navigationState.section)
  }
  if (navigationState.selectedUserId !== null) {
    setSelectedUserId(navigationState.selectedUserId)
  }
  setSelectedShopProductId(navigationState.selectedShopProductId)
  if (navigationState.section === 'pages' && navigationState.pageMode) {
    setPageEditorMode(navigationState.pageMode)
    setPageEditorId(navigationState.pageId)
  }
  if (navigationState.cleanQueryForHashRoutes) {
    window.history.replaceState({}, '', `${window.location.pathname}${window.location.hash}`)
  }
}
